import {
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Grid,
  Button,
  TextField,
  MenuItem,
  TableHead,
  Paper,
  Box,
  makeStyles,
  Breadcrumbs,
  Link,
  IconButton,
  Collapse,
  Checkbox,
  CircularProgress,
  DialogActions,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home"; // Import a home icon for the first breadcrumb
import NavigateNextIcon from "@material-ui/icons/NavigateNext"; // Optional: Custom separator icon
import React, { useEffect, useState } from "react";
import CustomDialogTitle from "./CustomDialogTitle";
import CustomButton from "./CusomButton";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Visibility,
  GetApp,
  ChevronRight,
} from "@material-ui/icons";
// import { presentDate } from "../functionalComponents/dataFormatFunctions";
import CollapsibleRow from "./CollapsibleRow";
import ViewCommentsDialog from "./ViewCommentsDialog";
import BatchDetails from "./BatchDetails";
import ExceptionDetails from "./ExceptionDetails";
import { fetchAllWorkItemDetails } from "../../../containers/actions/common/projectActions";
import { useDispatch, useSelector } from "react-redux";
import {
  DESTROY_BACKDROP,
  FETCH_ALL_WORK_ITEM_DETAILS,
  FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BatchDetailsUnitBox from "./dropdownComponents/BatchDetailsUnitBox";
import moment from "moment";
import BackDropLoading from "../models/BackDrop";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import CloseIcon from '@material-ui/icons/Close';
// import DraggableDialogTable from "./DraggableDialogTable";
import DraggableDialogTable1 from "./DraggableDialogTable1";
import ElectronicSignatureValidation from "./ElectronicSignatureValidation";
import CDMOCollapsibleRow from "./CDMOCollapsibleRow";
import DropdownRow from "./DropdownRow";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import DocumnetCollapsibleRow from "./DocumentCollapsibleRow";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
      fontSize: "80px",
    
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  // hrLine: {
  //   backgroundColor: 'grey',
  //   width: '2.5rem',
  //   height: '2px',
  // },
  header: {
    textAlign: "center",
  },
  flexGrow: {
    flexGrow: 1,
  },
  textFieldSty: {
    '& input.MuiInputBase-input.MuiOutlinedInput-input': {
      paddingTop: '10px',
      paddingBottom:'10px'
    }
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  }
}));

const renderStatus = (status) => {
  let color;
  switch (status) {
    case "Ongoing":
      color = "#FFA500"; // bright orange
      break;
    case "Completed":
      color = "#4CAF50"; // green
      break;
    case "Awaiting Start":
      color = "#A9A9A9"; // dark grey
      break;
    default:
      color = "#000";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
      }}
    >
      {status}
    </Typography>
  );
};

const DeliverablesScreen = (props) => {
  const classes = useStyles();
  const { openDialog, handleBackClick, projectData, deliverablesData } = props;
  //console.log("deliverablesData", deliverablesData);
  const dispatch = useDispatch();
  const [viewCommentsDialog, setViewCommentsDialog] = useState(false);
  const [commentWorkitem, setCommentWorkitem] = useState();
  const [openDialogBoxType, setDialogBox] = useState({
    openSuccessDialogBox: false,
    openElectronicSignDialog: false,
    openReviewApproveWorkflow: false,
    openFileUploaded: false,
    dialogBoxType: '',
    documentDetails: {}
  })
  const [error, setError] = useState(false)

  const openViewCommentsDialog = (selectedWorkitem) => {
    setViewCommentsDialog(true);
    setCommentWorkitem(selectedWorkitem);
  };
  const closeViewCommentsDialog = () => {
    setViewCommentsDialog(false);
  };

  const history = useHistory();
  const openProjectDashboard = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/projectsdashboard`
    );
  };

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
      payload: true,
    });
    dispatch(
      fetchAllWorkItemDetails({
        collabrixDeliverableID: deliverablesData.collabrixDeliverableID,
      })
    );
  }, []);

  const workItemDetailsLoading = useSelector(
    (state) => state.pcmp.common.Projects.workItemDetailsLoading
  );

  const workItemDetails = useSelector((state) =>
    state.pcmp.common.Projects.workItemDetails?.data
      ? state.pcmp.common.Projects.workItemDetails?.data?.workItemDetails
      : []
  );

  const errors = useSelector((state) =>
    state.pcmp.common.Projects.workItemDetails
      ? state.pcmp.common.Projects.workItemDetails
      : {
          status: false,
          errorDescription:
            "Something went wrong. Please contact Schrocken Suppport",
        }
  );

  const handleUpdateDocument = () => {
    let data = openDialogBoxType.documentDetails;
    //console.log('handleUpdateDocument')
    //console.log(data);
    dispatch({
      type: OPEN_BACKDROP,
    });
    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //   setDialogBox({...openDialogBoxType, openSuccessDialogBox:true, dialogBoxType: openDialogBoxType.documentDetails.qaDecision === 'Approved' ? 'documentApproved':'documentRejected'})
    // }, [3000]);
     const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/${openDialogBoxType.documentDetails.qaDecision === 'Approved' ? 'approval':'reject'}`
    // console.log(url)
    // console.log(data)
    axios
        .post(
          url,
          data
        )
        .then((res) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          if (res.data.status) {
            setDialogBox({...openDialogBoxType, openSuccessDialogBox:true, dialogBoxType: openDialogBoxType.documentDetails.qaDecision === 'Approved' ? 'documentApproved':'documentRejected'})
          } else {
            dispatch({
              type: DESTROY_BACKDROP,
            });
            setError(true)
          }
        })
        .catch((err) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          //console.log(err);
          setError(true)
        });

  }

  const handleCloseError = () => {
    setError(false)
  }

  const Row = ({ row, index, handleCloseError }) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <TableRow style={index % 2 !== 0 ? { backgroundColor: "#F9F9FC" } : {}}>
          <TableCell>
            <IconButton onClick={() => {
              handleCloseError()
              setOpen(!open)
            }
            }>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell style={{ minWidth: "200px" }}>
            {row.workItemDescription}
          </TableCell>
          <TableCell>
            {row.scheduledDeliveryDate ? moment(row.scheduledDeliveryDate).format("DD-MMM-YYYY").toUpperCase(): ' - '}
          </TableCell>
          <TableCell>
            {row.actualDeliveryDate ? moment(row.actualDeliveryDate).format("DD-MMM-YYYY").toUpperCase():' - '}
          </TableCell>
          <TableCell>{row.workItemStatus}</TableCell>
          <TableCell align="center">
            <Checkbox checked={row.qaApprovalRequired} />
          </TableCell>
          <TableCell align="center" style={{ minWidth: "430px" }}>
            <IconButton>
              <Visibility />
            </IconButton>
            <IconButton>
              <GetApp />
            </IconButton>
            {/* <CustomButton
              hasBorder={true}
              onClick={() => openViewCommentsDialog(row.collabrixWorkItemID)}
            >
              View Comments
            </CustomButton> */}
            <CustomButton
              hasBorder={true}
              style={{ marginLeft: "8px" }} // Add margin to separate the buttons
            >
              View Remarks
            </CustomButton>
            <IconButton>
              <CreateIcon />
            </IconButton>
          </TableCell>
        </TableRow>
        {open && row?.workItemTypeID === 2 && (
          localStorage.collabType !== 'CMO' ?
          <CollapsibleRow
            open={open}
            projectData={projectData}
            workItemDetails={workItemDetails}
            deliverablesData={deliverablesData}
            row={row}
            handleSuccessDialog={(type, documentDetails) => {
              //console.log(type)
              if (type === 'verifyElectronicSignature') {
                setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })

              } else {
                setDialogBox({ ...openDialogBoxType, openSuccessDialogBox: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
              }
            }
            }
          />
            :
          <CDMOCollapsibleRow
            open={open}
            projectData={projectData}
            workItemDetails={workItemDetails}
            deliverablesData={deliverablesData}
              row={row}
              handleSuccessSupportFileUpload={() => {
                setDialogBox({ ...openDialogBoxType, openFileUploaded: true })
              }
              }
            handleSuccessDialog={(type, documentDetails) => {
              if (type === 'verifyElectronicSignature') {
                setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })

              } else {
                setDialogBox({ ...openDialogBoxType, openSuccessDialogBox: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
              }
            }
            }
          />
        )}

{open && row?.workItemTypeID === 8 && (
          <DocumnetCollapsibleRow
            open={open}
            projectData={projectData}
            workItemDetails={workItemDetails}
            deliverablesData={deliverablesData}
            row={row}
            handleSuccessDialog={() => {
              setDialogBox({...openDialogBoxType, openFileUploaded:true})
            }
            }
          />
        )}

        {open && row?.workItemTypeID === 4 && (
          <BatchDetails
            projectData={projectData}
            open={open}
            workItemDetails={row}
          />
        )}
        {open && row?.workItemTypeID === 6 && (
          <ExceptionDetails
            open={open}
            projectData={projectData}
            workItemDetails={workItemDetails}
            deliverablesData={deliverablesData}
            row={row}
            addException={true}
          />
        )}
        {open && row?.workItemTypeID === 7 && (
          <ExceptionDetails
            open={open}
            projectData={projectData}
            workItemDetails={workItemDetails}
            deliverablesData={deliverablesData}
            row={row}
            addException={false}
          />
        )}
        {open && row?.workItemTypeID === 3 && (
          <BatchDetailsUnitBox open={open} workitemData={row} />
        )}
        {open && row?.workItemTypeID === 5 && (
          <BatchDetailsUnitBox open={open} workitemData={row} sample={true} />
        )}
      </>
    );
  };

  return (
    <Dialog open={openDialog} fullScreen>
      <CustomDialogTitle
        onBackClick={handleBackClick}
        title={`Description of Deliverables - ${deliverablesData.deliverableDescription[0]}`}
      />
      <DialogContent>
        <BackDropLoading />
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          style={{ margin: "18px 0" }}
        >
          {/* Home link with an icon */}
          <Link
            // href="/"
            color="secondary"
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => openProjectDashboard()}
          >
            <HomeIcon fontSize="small" style={{ marginRight: "4px" }} />
          </Link>

          {/* Project Dashboard link */}
          <Link
            //   href="/projectdashboard"
            style={{ cursor: "pointer" }}
            color="secondary"
            onClick={() => openProjectDashboard()}
          >
            Project Dashboard
          </Link>

          {/* Project Name link */}
          <Link
            //   href={`/project/${projectData.projectName}`}
            style={{ cursor: "pointer" }}
            color="secondary"
            onClick={() => handleBackClick()}
          >
            Compound ID - {projectData.projectName}
          </Link>

          {/* Final item as text (non-clickable) */}
          <Typography color="textPrimary">
            {deliverablesData.deliverableDescription}
          </Typography>
        </Breadcrumbs>

        {/* Project Details Table */}
        <TableContainer component={Paper} style={{ marginTop: "36px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Compound ID </TableCell>
                {localStorage.collabType !== 'CMO' && <TableCell>CMO</TableCell>}
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Deliverable Type
                </TableCell>
                <TableCell>BMS Department</TableCell>
                <TableCell>CMO Department</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell>BMS Team Members</TableCell>
                <TableCell>CMO Team Members</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{projectData.projectName}</TableCell>

                {localStorage.collabType !== 'CMO' && <TableCell>{projectData.cdmoOrgName}</TableCell>}

                <TableCell>{deliverablesData.deliverableTypeName}</TableCell>

                <TableCell>
                  {deliverablesData.sponsorDepartmentName != null
                    ? deliverablesData.sponsorDepartmentName
                    : "NA"}{" "}
                </TableCell>

                <TableCell>
                  {deliverablesData.cdmoDepartmentName != null
                    ? deliverablesData.cdmoDepartmentName
                    : "NA"}{" "}
                </TableCell>

                <TableCell variant="contained" color="secondary" align="center">
                  {renderStatus(deliverablesData.deliverableStatus)}
                </TableCell>

                <TableCell style={{ verticalAlign: "top"}}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    {deliverablesData.sponsorTeamMembersList.map(
                      (member, index) => (
                        <li key={index}>{member}</li>
                      )
                    )}
                  </ul>
                </TableCell>

                <TableCell style={{ verticalAlign: "top"}}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    {deliverablesData.cdmoTeamMembersList.map(
                      (member, index) => (
                        <li key={index}>{member}</li>
                      )
                    )}
                  </ul>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Deliverables and Signatory Details */}

        <TableContainer component={Paper} style={{ marginTop: "36px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "270px" }}>
                  BMS QA Signatory
                </TableCell>
                <TableCell style={{ width: "270px" }}>
                  BMS Subject Matter Expert Signatory
                </TableCell>
                <TableCell>CMO Point of Contact</TableCell>
                <TableCell>BMS Point of Contact</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{ verticalAlign: "top"}}>
                  {localStorage.collabType !== 'CMO' ? 
                    <>
                  <TextField
                    fullWidth
                    select
                    value={deliverablesData.sponsorQASignatoryName}
                    variant="outlined"
                    size="small"
                    style={{ marginBottom: "1rem" }}
                  >
                    {/* Mock data */}
                    <MenuItem value={deliverablesData.sponsorQASignatoryName}>
                      {deliverablesData.sponsorQASignatoryName}
                    </MenuItem>
                  </TextField>
                  
                    <CustomButton
                    color="#F26336" // Custom orange background
                    hoverColor="#D8542E" // Darker orange on hover
                    textColor="#fff" // Explicitly set white text color
                  >
                    Save
                    </CustomButton>
                    </>
                    :
                    <Typography>{deliverablesData.sponsorQASignatoryName}</Typography>
                  }
                  
                </TableCell>

                {deliverablesData.sponsorSMESignatoryList !== null ? (
                  <TableCell style={{ verticalAlign: "top" }}>
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                      {deliverablesData.sponsorSMESignatoryListNames.map(
                        (member, index) => (
                          <li key={index}>{member}</li>
                        )
                      )}
                    </ul>
                  </TableCell>
                ) : (
                    <TableCell style={{ verticalAlign: "top"}}>
                      {localStorage.collabType !== 'CMO' ?
                        <>
                    <TextField
                      fullWidth
                      select
                      value={deliverablesData.sponsorSMESignatoryName}
                      variant="outlined"
                      size="small"
                      style={{ marginBottom: "1rem" }}
                    >
                      {/* Mock data */}
                      <MenuItem
                        value={deliverablesData.sponsorSMESignatoryName}
                      >
                        {deliverablesData.sponsorSMESignatoryName}
                      </MenuItem>
                      </TextField>
                      
                    <CustomButton
                      color="#F26336" // Custom orange background
                      hoverColor="#D8542E" // Darker orange on hover
                      textColor="#fff" // Explicitly set white text color
                    >
                      Save
                        </CustomButton>
                        </> :
                        <Typography>{deliverablesData.sponsorSMESignatoryName}</Typography>
                      }
                  </TableCell>
                )}
                <TableCell style={{ verticalAlign: "top", maxWidth: "250px" }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                    marginBottom={1}
                  >
                    <Typography>{deliverablesData.cdmoPOCIDName}</Typography>
                    {localStorage.collabType !== "Pharma Co" && (
                      <CustomButton
                        color="#F26336" // Custom orange background
                        hoverColor="#D8542E" // Darker orange on hover
                        textColor="#fff" // Explicitly set white text color
                      >
                        Mark Deliverables as Complete
                      </CustomButton>
                    )}
                  </Box>
                  {localStorage.collabType !== "Pharma Co" && (
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Enter remarks here"
                      value={deliverablesData.cdmoPOCRemarks}
                      size="small"
                      multiline
                      rows={2}
                    />
                  )}
                </TableCell>

                <TableCell style={{ verticalAlign: "top", maxWidth: "250px" }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                    marginBottom={1}
                  >
                    <Typography>{deliverablesData.sponsorPOCIDName}</Typography>
                    {localStorage.collabType === "Pharma Co" && (
                      <CustomButton
                        color="#F26336" // Custom orange background
                        hoverColor="#D8542E" // Darker orange on hover
                        textColor="#fff" // Explicitly set white text color
                      >
                        Mark Deliverables as Complete
                      </CustomButton>
                    )}
                  </Box>
                  {localStorage.collabType === "Pharma Co" && (
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Enter remarks here"
                      value={deliverablesData.sponsorPOCRemarks}
                      size="small"
                      multiline
                      rows={2}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {error &&
        <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center", 
          }}
        >
        <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  width: "50%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
          </div>
          </div>
        }

        <Grid container className={classes.container}>
          <Grid item>
            <Typography variant="h6">Schedule of Deliverables</Typography>
            <hr className={classes.hrLine} />
          </Grid>
          <Grid item>
            <CustomButton
              color="#F26336" // Custom orange background
              hoverColor="#D8542E" // Darker orange on hover
              textColor="#fff" // Explicitly set white text color
              startIcon={<AddIcon />}
            >
              Add new record
            </CustomButton>
          </Grid>
        </Grid>

        <TableContainer component={Paper} style={{ marginBottom: "2rem" }}>
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: "#F9F9FC" }}>
                <TableCell />
                <TableCell>List of Documents/Work Items</TableCell>
                <TableCell>Scheduled Delivery Date</TableCell>
                <TableCell>Actual Delivery Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Require QA Approval</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workItemDetailsLoading ? (
                <TableRow>
                  <TableCell colSpan={7}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center", // Horizontally center the CircularProgress
                        alignItems: "center", // Vertically center the CircularProgress
                        height: "100px", // Optional: Set a height to vertically center the loader
                      }}
                    >
                      <CircularProgress />
                    </div>
                  </TableCell>
                </TableRow>
              ) : workItemDetails.length > 0 ? (
                  workItemDetails.map((row, index) => (
                    <Row key={index} row={row} index={index} handleCloseError={handleCloseError} />
                  // <DropdownRow key={index} row={row} index={index} projectData={projectData} workItemDetails={workItemDetails} deliverablesData={deliverablesData} openDialogBoxType={openDialogBoxType} setDialogBox={setDialogBox} />
                ))
              ) : errors.status === false ? (
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell colSpan={10} align="center">
                    {errors.errorDescription
                      ? errors.errorDescription
                      : "Please try again"}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow
                  style={{ border: "2px solid rgba(224, 224, 224, 1)" }}
                >
                  <TableCell colSpan={10} align="center">
                    {"No Record Found"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      {viewCommentsDialog === true && (
        <ViewCommentsDialog
          openDialog={viewCommentsDialog}
          workitemId={commentWorkitem}
          closeViewCommentsDialog={closeViewCommentsDialog}
        />
      )}
      {openDialogBoxType.openSuccessDialogBox && (
        <Dialog open={openDialogBoxType.openSuccessDialogBox} maxWidth="sm" fullWidth style={{ borderRadius: '14px' }}
        disableBackdropClick // Disable closing on outside click
          disableEscapeKeyDown // Disable closing on escape key
        >
          <DialogContent className={classes.dialogContent}>
            <>
              <CheckCircleIcon className={classes.avatar} />

              <Typography
                style={{
                  marginTop: "10px",
                  fontWeight: "600",
                                    color: "black",
                  fontSize:'2rem'
                }}
              >
                {openDialogBoxType.dialogBoxType ==='documentUploadedSuccess' ? 'Document Uploaded Successfully': openDialogBoxType.dialogBoxType==='reviewApprovalSaved' ? 'Review/approval workflow saved': openDialogBoxType.dialogBoxType==='electronicSignSuccess' ? 'Electronic Signature Applied Successfully': openDialogBoxType.dialogBoxType==='documentApproved' ? 'Document approved successfully': openDialogBoxType.dialogBoxType==='documentRejected' ? 'Document rejected successfully':'Success'}
                            </Typography>
              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    if (openDialogBoxType.dialogBoxType === 'electronicSignSuccess') {
                      setDialogBox({...openDialogBoxType, openSuccessDialogBox:false })
                      handleUpdateDocument()
                    } else {
                      setDialogBox({...openDialogBoxType, openSuccessDialogBox:false, openReviewApproveWorkflow: (openDialogBoxType.dialogBoxType === 'documentUploadedSuccess' && openDialogBoxType.documentDetails !=='' ) ? true: false})

                    }
                  }}
                >
                  {(openDialogBoxType.dialogBoxType === 'documentUploadedSuccess' && openDialogBoxType.documentDetails) ? 'Define review/approval workflow' : (openDialogBoxType.dialogBoxType === 'reviewApprovalSaved' || openDialogBoxType.dialogBoxType === 'documentApproved') ? 'Ok' : openDialogBoxType.dialogBoxType === 'electronicSignSuccess' ? openDialogBoxType.documentDetails.qaDecision ==='Approved' ? 'Approve the document': 'Reject the document' : openDialogBoxType.dialogBoxType==='documentRejected' ? 'Ok': 'Ok'}
                </Button>
              </DialogActions>
            </>
          </DialogContent>
        </Dialog>
      )}
      {openDialogBoxType.openFileUploaded && (
        <Dialog open={openDialogBoxType.openFileUploaded} maxWidth="sm" fullWidth style={{ borderRadius: '14px' }}
        disableBackdropClick // Disable closing on outside click
          disableEscapeKeyDown // Disable closing on escape key
        >
          <DialogContent className={classes.dialogContent}>
            <>
              <CheckCircleIcon className={classes.avatar} />

              <Typography
                style={{
                  marginTop: "10px",
                  fontWeight: "600",
                                    color: "black",
                  fontSize:'2rem'
                }}
              >
                Document Uploaded Successfully
                            </Typography>
              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                      setDialogBox({...openDialogBoxType, openFileUploaded:false})
                  }}
                >
                    Ok
                </Button>
              </DialogActions>
            </>
          </DialogContent>
        </Dialog>
      )}
      {openDialogBoxType.openElectronicSignDialog &&

        <ElectronicSignatureValidation
        open={openDialogBoxType.openElectronicSignDialog}
        onClose={() => setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: false })}
        classes={classes}
        documentDetails={openDialogBoxType.documentDetails}
        handleESignatureSuccess={(type) => {
          setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: false, openSuccessDialogBox: true, dialogBoxType: type })
        }
        }
      />
      }
      {openDialogBoxType.openReviewApproveWorkflow &&
        <DraggableDialogTable1
        open={openDialogBoxType.openReviewApproveWorkflow}
        handleClose={() => setDialogBox({ ...openDialogBoxType, openReviewApproveWorkflow: false })}
        deliverablesData={deliverablesData}
        handleReviewApproveSuccess={(type) => {
          setDialogBox({ ...openDialogBoxType, openReviewApproveWorkflow: false, openSuccessDialogBox: true, dialogBoxType: type })
        }
        }
        document={openDialogBoxType.documentDetails}
      />
      }

    </Dialog>
  );
};

export default DeliverablesScreen;
